import MobileShowAllFilters from "@/components/Search/components/MobileShowAllFilters";
import { FILTER_CATEGORIES } from "@/components/Search/constants";
import { FilterVersion } from "@/components/Search/types";
import RecentlyAddedDropdown from "./components/RecentlyAddedDropdown";
import FilterDropdown from "./components/Dropdown";

export const SearchFilters = () => (
  <div>
    <div className="container gap-4 p-0">
      <div className="flex overflow-x-auto gap-4 scrollbar-thin relative w-full">
        <MobileShowAllFilters filterVersion={FilterVersion.HorizontalFilter} />
        {FILTER_CATEGORIES.map((facet) => (
          <FilterDropdown key={facet} filterCategory={facet} />
        ))}
        <RecentlyAddedDropdown />
      </div>
    </div>
  </div>
);

export default SearchFilters;
